import { render, staticRenderFns } from "./PaginaAdminTiposSocio.vue?vue&type=template&id=3e5d4267&lang=true"
import script from "./PaginaAdminTiposSocio.vue?vue&type=script&lang=js"
export * from "./PaginaAdminTiposSocio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports